import { AbstractMesh } from '@babylonjs/core/Meshes/abstractMesh'
import { TransformNode } from '@babylonjs/core/Meshes/transformNode'
import Part from './Part'

export default class Bushing extends Part {
	constructor(parent: TransformNode = null, mirror: boolean = false) {
		super('BUSHING', parent, mirror)
	}

	override get isPrecious(): boolean {
		return /^AU750|PT950/.test(this.config.components.TEMPLE?.color)
	}

	override get filename(): string {
		return this.config.components.BUSHING?.design ? `Bushings/${this.isPrecious ? 'Precious' : 'Titanium'}/${this.config.components.BUSHING.design}` : null
	}

	override getMeshMaterialName(mesh: AbstractMesh): string {
		if (mesh.name.startsWith('BUSHING')) {
			return this.config.components.BUSHING?.color
		} else {
			throw (`Unexpected ${this.name} mesh: (${mesh.name})`)
		}
	}
}
